export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";